import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const AddFundsToolbar = ({ currentTab, handleTab }) => {
  const { t } = useTranslation(['rewards-gift'])
  return (
    <nav className="ctp-toolbar-menu">
      <ul>
        <li>
          <a
            className={currentTab === 'card' ? 'is-active' : ''}
            onClick={() => (currentTab === 'card' ? null : handleTab('card'))}
          >
            <span>{t('rewards-gift:addFunds.creditCardTab')}</span>
          </a>
        </li>
        <li>
          <a
            className={currentTab === 'invoice' ? 'is-active' : ''}
            onClick={() => (currentTab === 'invoice' ? null : handleTab('invoice'))}
          >
            <span>{t('rewards-gift:addFunds.payByInvoiceTab')}</span>
          </a>
        </li>
      </ul>
    </nav>
  )
}

AddFundsToolbar.propTypes = {
  handleTab: PropTypes.func,
  currentTab: PropTypes.string,
}

export default AddFundsToolbar
